import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LotAdjustmentHandoverContent from '../content/lotAdjustmentHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class LotAdjustmentHandover extends React.Component {
	static getTitle(report) {
		return `Lot Adjustment ${report.lotNo}`;
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<LotAdjustmentHandoverContent report={report} />
		);
	}
}

LotAdjustmentHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	LotAdjustmentHandover, {
		title: 'Lot Adjustment',
		className: 'lot-adjustment-handover'
	})
);
